(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const body = document.body;

  const money = (cents) => {
    const format = window.MFTheme?.moneyFormat || '${{amount}}';
    const value = (Number(cents || 0) / 100).toFixed(2);
    return format.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, (_, noDec) => noDec ? Math.round(Number(cents || 0) / 100) : value).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  };

  const setDrawer = (id, open) => {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    body.classList.toggle('drawer-open', open);
    if (open) setTimeout(() => drawer.querySelector('input,button,a')?.focus(), 80);
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-search]')) setDrawer('SearchDrawer', true);
    if (e.target.closest('[data-close-search]')) setDrawer('SearchDrawer', false);
    if (e.target.closest('[data-open-cart]')) setDrawer('CartDrawer', true);
    if (e.target.closest('[data-close-cart]')) setDrawer('CartDrawer', false);
    const menu = e.target.closest('[data-mobile-menu]');
    if (menu) {
      const nav = document.getElementById('MobileNav');
      nav?.classList.toggle('is-open');
      menu.setAttribute('aria-expanded', nav?.classList.contains('is-open') ? 'true' : 'false');
    }
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      setDrawer('SearchDrawer', false);
      setDrawer('CartDrawer', false);
    }
  });

  const header = $('.site-header');
  if (header) window.addEventListener('scroll', () => header.classList.toggle('is-scrolled', scrollY > 20), { passive:true });

  class SimpleCarousel {
    constructor(el) {
      this.el = el;
      this.slides = $$('[data-slide]', el);
      this.dots = $$('[data-dot]', el);
      this.index = Math.max(0, this.slides.findIndex(x => x.classList.contains('is-active')));
      this.autoplay = el.dataset.autoplay === 'true';
      this.delay = Number(el.dataset.delay || 5) * 1000;
      this.timer = null;
      this.paused = false;
      if (this.slides.length < 2) return;
      $('[data-next]', el)?.addEventListener('click', () => this.go(this.index + 1));
      $('[data-prev]', el)?.addEventListener('click', () => this.go(this.index - 1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
      $('[data-pause]', el)?.addEventListener('click', e => {
        this.paused = !this.paused;
        e.currentTarget.textContent = this.paused ? 'Play' : 'Pause';
        this.paused ? this.stop() : this.start();
      });
      el.addEventListener('mouseenter', () => this.stop());
      el.addEventListener('mouseleave', () => !this.paused && this.start());
      if (this.autoplay && !matchMedia('(prefers-reduced-motion: reduce)').matches) this.start();
    }
    go(i) {
      this.index = (i + this.slides.length) % this.slides.length;
      this.slides.forEach((s, n) => {
        const active = n === this.index;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      this.dots.forEach((d, n) => d.classList.toggle('is-active', n === this.index));
      if (this.autoplay && !this.paused) { this.stop(); this.start(); }
    }
    start() { this.stop(); this.timer = setInterval(() => this.go(this.index + 1), this.delay); }
    stop() { if (this.timer) clearInterval(this.timer); this.timer = null; }
  }

  const initCarousels = (scope = document) => $$('[data-carousel]', scope).forEach(el => { if (!el._mfCarousel) el._mfCarousel = new SimpleCarousel(el); });
  initCarousels();

  const renderCart = async (open = false) => {
    try {
      const res = await fetch('/cart.js', { headers: { Accept:'application/json' } });
      const cart = await res.json();
      $$('[data-cart-count]').forEach(el => el.textContent = el.classList.contains('drawer__count') ? `(${cart.item_count})` : cart.item_count);
      const bodyEl = $('[data-cart-drawer-body]');
      const footer = $('[data-cart-drawer-footer]');
      if (!bodyEl) return;
      if (!cart.item_count) {
        bodyEl.innerHTML = '<div class="empty-state"><p>Your cart is empty.</p><a class="button button--solid" href="/collections/all">Shop all</a></div>';
        if (footer) footer.hidden = true;
      } else {
        bodyEl.innerHTML = cart.items.map(item => `
          <div class="cart-line" data-line-key="${item.key}">
            <a class="cart-line__image" href="${item.url}">${item.image ? `<img src="${item.image}&width=220" alt="">` : ''}</a>
            <div class="cart-line__info">
              <a class="cart-line__title" href="${item.url}">${item.product_title}</a>
              ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-line__variant">${item.variant_title}</div>` : ''}
              <div class="cart-line__bottom"><span>${money(item.final_line_price)}</span><button class="text-button" type="button" data-cart-remove="${item.key}">Remove</button></div>
            </div>
          </div>`).join('');
        if (footer) footer.hidden = false;
        $('[data-cart-total]') && ($('[data-cart-total]').textContent = money(cart.total_price));
      }
      if (open) setDrawer('CartDrawer', true);
    } catch (err) { console.error(err); }
  };

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-ajax-cart-form]');
    if (!form) return;
    if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
    e.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const original = button?.textContent;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try {
      const res = await fetch(window.MFTheme?.routes?.cartAdd || '/cart/add.js', { method:'POST', body:new FormData(form), headers:{Accept:'application/json'} });
      if (!res.ok) throw new Error((await res.json()).description || 'Unable to add item');
      await renderCart(true);
    } catch (err) {
      alert(err.message || 'Unable to add item.');
    } finally {
      if (button) { button.disabled = false; button.textContent = original; }
    }
  });

  document.addEventListener('click', async (e) => {
    const remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      remove.disabled = true;
      await fetch(window.MFTheme?.routes?.cartChange || '/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({ id:remove.dataset.cartRemove, quantity:0 }) });
      await renderCart(false);
    }
    const q = e.target.closest('[data-qty-change]');
    if (q) {
      const wrap = q.closest('[data-quantity]');
      const input = $('input[type="number"]', wrap);
      if (input) input.value = Math.max(1, Number(input.value || 1) + Number(q.dataset.qtyChange));
    }
    const filter = e.target.closest('[data-filter-toggle]');
    if (filter) $('.filters')?.classList.toggle('is-open');
  });

  const initProduct = (scope = document) => {
    $$('[data-product-root]', scope).forEach(root => {
      if (root._mfInit) return; root._mfInit = true;
      const json = $('[data-variants-json]', root);
      if (!json) return;
      const variants = JSON.parse(json.textContent);
      const form = $('form[action*="/cart/add"]', root);
      const preorder = Boolean(form?.querySelector('input[name="selling_plan"]'));
      const variantInput = $('input[name="id"]', form);
      const price = $('[data-product-price]', root);
      const compare = $('[data-product-compare]', root);
      const submit = $('[data-product-submit]', root);
      const sticky = document.querySelector('[data-sticky-atc]');
      const optionInputs = $$('[data-option-input]', root);
      const update = () => {
        const selected = [];
        const indexes = [...new Set(optionInputs.map(i => i.dataset.optionIndex))];
        indexes.forEach(idx => {
          const checked = $(`[data-option-input][data-option-index="${idx}"]:checked`, root);
          if (checked) selected.push(checked.value);
        });
        const variant = variants.find(v => v.options.every((o,i) => o === selected[i]));
        if (!variant) { submit && (submit.disabled = true, submit.textContent = 'Unavailable'); return; }
        variantInput.value = variant.id;
        if (price) price.textContent = money(variant.price);
        if (compare) { compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : ''; compare.hidden = !(variant.compare_at_price > variant.price); }
        if (submit) { submit.disabled = !variant.available; submit.textContent = variant.available ? (preorder ? 'Reserve Pre-Order' : 'Add to cart') : 'Sold out'; }
        $$('[data-sticky-price]').forEach(el => el.textContent = money(variant.price));
        history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
      };
      optionInputs.forEach(i => i.addEventListener('change', update));
      update();
      if (sticky) {
        const observer = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold:.15 });
        submit && observer.observe(submit);
      }
    });
  };
  initProduct();

  if (body.dataset.reveal === 'true') {
    const obs = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); obs.unobserve(entry.target); } }), { threshold:.08 });
    $$('.reveal').forEach(el => obs.observe(el));
  }

  document.addEventListener('shopify:section:load', e => { initCarousels(e.target); initProduct(e.target); });
})();

(() => {
  const initImageViewer = (scope = document) => {
    scope.querySelectorAll('[data-image-viewer]').forEach(dialog => {
      if (dialog.dataset.initialized) return;
      dialog.dataset.initialized = 'true';
      const root = dialog.closest('[data-product-root]');
      const image = dialog.querySelector('[data-image-viewer-image]');
      const stage = dialog.querySelector('[data-image-viewer-stage]');
      const caption = dialog.querySelector('[data-image-viewer-caption]');
      const toggle = dialog.querySelector('[data-zoom-label]');
      let trigger = null;
      const setZoom = zoomed => {
        stage.classList.toggle('is-zoomed', zoomed);
        toggle.setAttribute('aria-pressed', String(zoomed));
        toggle.textContent = zoomed ? toggle.dataset.fitLabel : toggle.dataset.zoomLabel;
        stage.scrollLeft = zoomed ? Math.max(0, (stage.scrollWidth - stage.clientWidth) / 2) : 0;
        stage.scrollTop = zoomed ? Math.max(0, (stage.scrollHeight - stage.clientHeight) / 2) : 0;
      };
      root.addEventListener('click', event => {
        const button = event.target.closest('[data-image-zoom]');
        if (!button) return;
        const source = button.querySelector('img');
        if (!source || !source.src) return;
        trigger = button;
        image.src = source.dataset.zoomSrc || source.currentSrc || source.src;
        image.alt = source.alt;
        caption.textContent = source.alt;
        setZoom(false);
        document.body.classList.add('image-viewer-open');
        dialog.showModal();
      });
      dialog.querySelectorAll('[data-image-viewer-toggle]').forEach(button => {
        button.addEventListener('click', () => setZoom(!stage.classList.contains('is-zoomed')));
      });
      dialog.querySelector('[data-image-viewer-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => {
        document.body.classList.remove('image-viewer-open');
        setZoom(false);
        trigger?.focus({preventScroll:true});
      });
    });
  };
  initImageViewer();
  document.addEventListener('shopify:section:load', event => initImageViewer(event.target));
})();
